// Human-friendly lead source labels. Imports are stored as "csv_import:<filename>"
// which is ugly on cards/tables — show a clean label and keep the filename as a tooltip.
export function formatLeadSource(source) {
  const raw = (source || '').trim();
  if (!raw) return { label: 'No source', title: '' };
  const lower = raw.toLowerCase();
  if (lower.startsWith('csv_import:') || lower.startsWith('xlsx_import:') || lower.startsWith('import:')) {
    return { label: 'CSV Import', title: raw.split(':').slice(1).join(':') };
  }
  if (lower.includes('apollo')) return { label: 'Apollo', title: raw };
  return { label: raw, title: raw };
}
